import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError} from 'rxjs/operators';

@Injectable()
export class AccountProvider {

    constructor(private _http: HttpClient) {
    }

    loginUser(username: String, password: String): Observable<any> {
        return this._http.post('/accounts/authenticate',
                            {
                                'username': username,
                                'password': password
                            },
                            {observe: 'response'}
                        )
                        .pipe(
                            catchError(this.handleError)
                        );
    }

    authorizeUser(): Observable<any> {
        return this._http.post('/accounts/authorize',
                            { },
                            {observe: 'response'}
                        )
                        .pipe(
                            catchError(this.handleError)
                        );
    }

    logout(): Observable<any> {
        return this._http.post('/accounts/logout',
                            { },
                            {observe: 'response'}
                        )
                        .pipe(
                            catchError(this.handleError)
                        )
    }


    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
            console.log(error.error);
        }
        // return an observable with a user-facing error message
        return throwError('Something bad happened retrieving your account; please try again later.');
    }

    private extractData(res: Response) {
        const body = res;
        return body || { };
    }
}
